/*
 * Minimal dependency-free JSON syntax highlighter. Pretty-prints a value and wraps tokens
 * (keys, strings, numbers, booleans, null) in spans coloured via Shell.scss.
 */

function escapeHtml(s: string): string {
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

const TOKEN = /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false)\b|\bnull\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g;

function highlightJson(value: unknown): string {
    const pretty = escapeHtml(JSON.stringify(value, null, 2));
    return pretty.replace(TOKEN, match => {
        let cls = "shell-json-number";
        if (/^"/.test(match)) {
            cls = /:$/.test(match) ? "shell-json-key" : "shell-json-string";
        } else if (/true|false/.test(match)) {
            cls = "shell-json-boolean";
        } else if (/null/.test(match)) {
            cls = "shell-json-null";
        }
        return `<span class="${cls}">${match}</span>`;
    });
}

export const JsonHighlight = ({value}: {value: unknown}) => {
    // input is escaped before token spans are added, so this is safe
    return <pre className="shell-json" dangerouslySetInnerHTML={{__html: highlightJson(value)}}/>;
};
